<template>
  <div>
    <div class="columns">
      <div class="column is-9">
        <b-field v-if="options">
          <b-input v-model="searchName" placeholder="Search delivery boy in this city"></b-input>
        </b-field>
      </div>
      <div class="column is-3">
        <a class="button full-width-button is-outlined is-primary" @click="openModal">
            <span class="icon is-small">
              <i class="fas fa-plus"></i>
            </span>
            <span>Add</span>
          </a>
      </div>
    </div>
    <div class="columns is-multiline">
      <div class="column is-6" v-for="option in filterBy(options, searchName)" :key="option.docId">
        <div class="card">
          <div class="card-content">
            <strong :title="option.label">{{option.label | truncate(40)}}</strong>
            <p>Closes: {{option.closeTime}}</p>
          </div>
          <footer class="card-footer">
            <a class="card-footer-item" @click="openModal(option)">Edit</a>
            <b-upload class="card-footer-item" v-model="files" @input="uploadImage(option)">
              <a>
                <span>Upload image</span>
              </a>
            </b-upload>
            <a class="card-footer-item" @click="deleteOption(option)">Delete</a>
          </footer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ManageDeliveryOption from './ManageDeliveryOption';
import DeliveryOptionsService from './service';
import UploadService from '../../../lib/UploadService';

export default {
  name: 'deliveryOptions',

  props: ['city'],

  created() {
    this.fetchDeliveryOptions();
    this.$bus.$on('CITY_CHANGED', city => {
      // this.city = city;
      this.fetchDeliveryOptions();
    });
  },

  data() {
    return {
      isLoading: true,
      searchName: null,
      options: null,
      files: null
    };
  },

  methods: {
    fetchDeliveryOptions() {
      DeliveryOptionsService.all(this.city).then(data => {
        this.options = data;
        this.isLoading = false;
      });
    },

    deleteOption(optionToBeDeleted) {
      this.$dialog.confirm({
        message: 'Sure to delete delivery option?',
        onConfirm: () => {
          this.isLoading = true;

          DeliveryOptionsService.deleteOption(
            this.city,
            optionToBeDeleted
          ).then(() => {
            this.options = this.options.filter(
              option => option.docId !== optionToBeDeleted.docId
            );
            this.isLoading = false;
            this.$toast.open('Delivery option deleted successfully');
          });
        }
      });
    },

    openModal(option = null) {
      this.$modal.open({
        parent: this,
        props: {
          option,
          city: this.city
        },
        component: ManageDeliveryOption,
        hasModalCard: true
      });
    },

    uploadImage(option) {
      UploadService(
        this.files[0],
        `cities/${this.city.docId}/delivery-options`,
        option.docId
      )
        .then(() => {
          this.isLoading = false;
          this.$toast.open('Image saved successfully');
        })
        .catch(() => {
          this.isLoading = false;
          this.$toast.open('Error saving image');
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/cities/DeliveryOptions/DeliveryOptions.vue